// Saves a video blob straight to the user's Downloads folder — same reliable
// blob → object-URL → anchor flow we use for PDFs. We intentionally do NOT use
// navigator.share() here: on iOS that pops the native "Save to Files/Photos"
// share sheet, but users expect a plain download to their Downloads folder
// (just like the PDF). The server sends Content-Disposition: attachment, so
// this downloads directly everywhere.
export async function saveOrShareVideo(blob, filename, _title) {
  const name = filename && filename.toLowerCase().endsWith(".mp4") ? filename : `${filename || "video"}.mp4`;
  const file = new Blob([blob], { type: "video/mp4" });
  const url = window.URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
